(() => {
  function initTokenVariantGrids(root = document) {
    const grids = root.querySelectorAll('.token-variant-grid-wrap');

    grids.forEach((grid) => {
      /*
       * IMPORTANT:
       * Prevent the same grid from being initialized twice.
       * This is what fixes the +2 / -2 problem.
       */
      if (grid.dataset.tokenGridInitialized === 'true') {
        return;
      }

      grid.dataset.tokenGridInitialized = 'true';

      const addButton = grid.querySelector('.token-add-selected');
      const message = grid.querySelector('.token-grid-message');

      function getQuantity(input) {
        if (!input) return 0;

        const raw = String(input.value || '').trim();

        if (raw === '') return 0;

        const value = parseInt(raw, 10);

        if (Number.isNaN(value) || value < 0) {
          return 0;
        }

        return value;
      }

      function normalizeInput(input) {
        let value = getQuantity(input);

        if (value < 0 || Number.isNaN(value)) {
          value = 0;
        }

        input.value = value;
      }

      /*
       * PLUS / MINUS BUTTONS
       */
      grid.addEventListener('click', (event) => {
        const plusButton = event.target.closest('.token-qty-plus');
        const minusButton = event.target.closest('.token-qty-minus');

        if (!plusButton && !minusButton) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const qtyBox = event.target.closest('.token-qty-box');

        if (!qtyBox) return;

        const input = qtyBox.querySelector('.token-variant-qty');

        if (!input) return;

        let quantity = getQuantity(input);

        if (plusButton) {
          quantity += 1;
        }

        if (minusButton) {
          quantity = Math.max(0, quantity - 1);
        }

        input.value = quantity;

        /*
         * Fire change event in case anything else
         * on the theme is listening to the field.
         */
        input.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      });

      /*
       * MANUAL QUANTITY ENTRY
       */
      grid
        .querySelectorAll('.token-variant-qty')
        .forEach((input) => {
          input.addEventListener('focus', () => {
            if (input.value === '0') {
              input.select();
            }
          });

          input.addEventListener('input', () => {
            /*
             * Numbers only.
             */
            let value = String(input.value).replace(/[^0-9]/g, '');

            /*
             * Remove leading zeros while allowing 0 itself.
             */
            if (value.length > 1) {
              value = value.replace(/^0+/, '');
            }

            input.value = value;
          });

          input.addEventListener('blur', () => {
            if (
              input.value.trim() === '' ||
              Number.isNaN(parseInt(input.value, 10))
            ) {
              input.value = '0';
            } else {
              normalizeInput(input);
            }
          });
        });

      /*
       * ADD ALL SELECTED VARIANTS TO CART
       */
      if (addButton) {
        addButton.addEventListener('click', async (event) => {
          event.preventDefault();

          const items = [];

          grid
            .querySelectorAll('.token-variant-qty')
            .forEach((input) => {
              const quantity = getQuantity(input);
              const variantId = Number(input.dataset.variantId);

              if (
                quantity > 0 &&
                variantId &&
                !input.disabled
              ) {
                items.push({
                  id: variantId,
                  quantity: quantity
                });
              }
            });

          if (!items.length) {
            if (message) {
              message.textContent =
                'Please select at least one item.';
              message.classList.add('is-error');
              message.classList.remove('is-success');
            }

            return;
          }

          const originalText = addButton.textContent;

          addButton.disabled = true;
          addButton.textContent = 'Adding…';

          if (message) {
            message.textContent = '';
            message.classList.remove(
              'is-error',
              'is-success'
            );
          }

          try {
            const cart =
              document.querySelector('cart-drawer') ||
              document.querySelector('cart-notification');

            const sectionsToRender =
              cart && typeof cart.getSectionsToRender === 'function'
                ? cart.getSectionsToRender()
                : [];

            const requestBody = {
              items: items
            };

            if (sectionsToRender.length) {
              requestBody.sections =
                sectionsToRender.map((section) => section.id);
              requestBody.sections_url =
                window.location.pathname;
            }

            if (
              cart &&
              typeof cart.setActiveElement === 'function'
            ) {
              cart.setActiveElement(addButton);
            }

            const response = await fetch(
              window.routes?.cart_add_url
                ? `${window.routes.cart_add_url}.js`
                : '/cart/add.js',
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(requestBody)
              }
            );

            const data = await response.json();

            if (!response.ok || data.status || data.errors) {
              throw new Error(
                data.description ||
                data.message ||
                data.errors ||
                'Unable to add these items to the cart.'
              );
            }

            if (cart) {
              cart.classList.remove('is-empty');
            }

            if (
              cart &&
              data.sections &&
              typeof cart.renderContents === 'function'
            ) {
              cart.renderContents(data);
            } else if (cart && typeof cart.renderContents === 'function') {
              const sectionResponse = await fetch(
                `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`
              );
              const sections = await sectionResponse.json();

              cart.renderContents({
                id: items[0]?.id,
                sections: sections
              });
            }

            if (
              typeof publish === 'function' &&
              typeof PUB_SUB_EVENTS !== 'undefined' &&
              PUB_SUB_EVENTS.cartUpdate
            ) {
              try {
                await Promise.resolve(
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'token-variant-grid',
                    productVariantId: String(items[0]?.id || ''),
                    cartData: data
                  })
                );
              } catch (publishError) {
                console.warn(
                  'Token variant grid cartUpdate publish warning:',
                  publishError
                );
              }
            }

            if (message) {
              message.textContent =
                'Selected items were added to your cart.';

              message.classList.add('is-success');
              message.classList.remove('is-error');
            }

            grid
              .querySelectorAll('.token-variant-qty')
              .forEach((input) => {
                input.value = '0';
              });

          } catch (error) {
            console.error(
              'Token variant grid error:',
              error
            );

            if (message) {
              message.textContent =
                error.message ||
                'Something went wrong. Please try again.';

              message.classList.add('is-error');
              message.classList.remove('is-success');
            }
          } finally {
            addButton.disabled = false;
            addButton.textContent = originalText;
          }
        });
      }
    });
  }

  /*
   * Normal page load.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initTokenVariantGrids();
      },
      { once: true }
    );
  } else {
    initTokenVariantGrids();
  }

  /*
   * Shopify Theme Editor can dynamically reload sections.
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initTokenVariantGrids(event.target);
    }
  );
})();